//for remove a blur button
export const removeBlurButton = async (reference) => {
    const buttons = reference.querySelectorAll('button');
    for(let i = 0; i < buttons.length; i++) {
        buttons[i].blur();
    }
}